module.exports = __webpack_public_path__ + "img/51.45c94b1c.jpg";